export const normalizeSneakPeekText = value =>
  `${value || ''}`
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001f\u007f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const typingUsersBesideDraft = (users, hasDraft) =>
  hasDraft ? users.filter(user => user.type !== 'contact') : users;

export const isScrolledToBottom = panel =>
  Boolean(panel) &&
  panel.scrollHeight - panel.scrollTop - panel.clientHeight <= 8;
